import { RefObject, useLayoutEffect, useState } from 'react';

export const useElementHeight = (ref: RefObject<HTMLElement>) => {
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => {
    setHeight(ref.current?.clientHeight || 0)
  }, [ref.current?.clientHeight])
  return height;
}
